/** @format */

import React from "react";
import LabelInput from "./labelInput";
import { assetsPath } from "../utils/assetsPath";

const DriverNameFields = ({
  register,
  errors,
  watch,
  trigger,
  prefix = "",
}) => (
  <div className="nameFields">
    <LabelInput
      id={`${prefix}firstName`}
      label="First name"
      type="text"
      placeholder="Enter your first name"
      register={register(`${prefix}firstName`, {
        required: "Required",
      })}
      errors={errors && errors[`${prefix}firstName`]}
      watch={watch(`${prefix}firstName`)}
      trigger={trigger}
      className="nameFieldsStyle"
    />
    <LabelInput
      id={`${prefix}lastName`}
      label="Last name"
      type="text"
      placeholder="Enter your last name"
      register={register(`${prefix}lastName`, {
        required: "Required",
      })}
      errors={errors && errors[`${prefix}lastName`]}
      watch={watch(`${prefix}lastName`)}
      trigger={trigger}
      className="nameFieldsStyle"
    />
  </div>
);

export default DriverNameFields;
